import { render, staticRenderFns } from "./ResponsaveisFiscaisForm.vue?vue&type=template&id=c930cf9e&scoped=true"
import script from "./ResponsaveisFiscaisForm.vue?vue&type=script&lang=js"
export * from "./ResponsaveisFiscaisForm.vue?vue&type=script&lang=js"
import style0 from "./ResponsaveisFiscaisForm.vue?vue&type=style&index=0&id=c930cf9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c930cf9e",
  null
  
)

export default component.exports